export default __webpack_public_path__ + "static/media/advancedmedicine-default-logo.9a40f766.png";